module.exports = __webpack_public_path__ + "static/img/98024B_3_R_20200331_fit.04b28e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/98024B_3_R_20200331_fit.png
// module id = OuBM
// module chunks = 0